import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { defer, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AdminClustersResolver } from '../../resolver/admins-clusters-resolver.service';

@Injectable({ providedIn: 'root' })
export class AdminClusterGuard implements CanActivate {
  constructor(
    private readonly adminClustersResolver: AdminClustersResolver,
    private readonly router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return defer(() => this.adminClustersResolver.resolve()).pipe(
      map((clusters) => clusters.length > 0 || this.redirectToDashboard()),
      catchError(() => of(this.redirectToDashboard())),
    );
  }

  private redirectToDashboard(): UrlTree {
    return this.router.createUrlTree(['/dashboard']);
  }
}
